import React, { useState } from "react";
import { ROOT_ADMIN, ROOT_EMPLOYEE } from "../constants/HelperConstants";
import {
  PAY_PUP_ADMIN_EMAIL,
  PAY_PUP_LS_AUTH_TOKEN,
  PAY_PUP_LS_AUTH_USER_ID,
  PAY_PUP_LS_AUTH_USER_ROLE,
  PAY_PUP_LS_AGENCY_ID,
  PAY_PUP_IS_ROOTUSER,
  PAY_PUP_AGENCY_URL,
} from "../constants/LocalStorageVariables";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import {
  ADMIN_DASHBOARD_ROUTE,
  AGENCY_DASHBOARD_ROUTE,
} from "../constants/RoutePaths";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { authHeader } from "../functions/CoreFunctions";
import API from "../redux/actions/API";
import { CustomAlertMessage } from "../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { FIRST_TIME_PASSWORD_URL } from "../constants/ApiPaths";
import { getAdminEmail } from "./common/CommonFunctions";
import CustomButtonLoader from "./CustomComponents/CustomButtonLoader";
import logo from "../images/logo.png";
import Iconawesomeeye from "../images/Iconawesomeeye.svg";
import Iconionicmdeyeoff from "../images/Iconionicmdeyeoff.svg";
import { AUTH_USER_DETAILS_SUCCESS } from "../redux/actions/ActionTypes";

export default function ResetPassword(props) {
  const { UserData, token } = props;
  const [oldPasswordShown, SetOldPasswordShown] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmpasswordShown, setconfirmPasswordShown] = useState(false);
  const dispatch = useDispatch();

  const oldTogglePassword = () => {
    SetOldPasswordShown(oldPasswordShown ? false : true);
  };

  const togglePassword = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const confirmTogglePassword = () => {
    setconfirmPasswordShown(confirmpasswordShown ? false : true);
  };

  const history = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  console.log("FIRSSTTIMEPASS");
  const validationSchema = Yup.object({
    oldPassword: Yup.string().trim().required("Password is required"),
    newPassword: Yup.string().trim().required("New Password Required"),
    confirmPassword: Yup.string()
      .required("Confirm password is required")
      .test("passwords-match", "Password mismatch", function (value) {
        return this.parent.newPassword === value;
      }),
  });
  const saveFormValues = async (values) => {
    setLoading(true);
    const config = {
      method: "PUT",
      url: FIRST_TIME_PASSWORD_URL,
      data: {
        oldPassword: values.oldPassword,
        newPassword: values.newPassword,
        email: getAdminEmail(),
        hyperlink: window.location.host,
      },
      headers: authHeader(),
    };

    try {
      const response = await API(config);
      const { status } = response.data;
      if (status === "Success") {
        const { email, agencyId, userId, roleName, isRootUser, agencyUrl } =
          UserData;

        dispatch({
          type: AUTH_USER_DETAILS_SUCCESS,
          payload: UserData,
        });

        localStorage.setItem(PAY_PUP_LS_AUTH_TOKEN, token);
        localStorage.setItem(PAY_PUP_LS_AUTH_USER_ROLE, roleName);
        const Role = localStorage.getItem(PAY_PUP_LS_AUTH_USER_ROLE);
        const Root = [ROOT_ADMIN, ROOT_EMPLOYEE].includes(Role);
        localStorage.setItem(PAY_PUP_LS_AUTH_USER_ID, userId);
        localStorage.setItem(PAY_PUP_LS_AGENCY_ID, agencyId);
        localStorage.setItem(PAY_PUP_ADMIN_EMAIL, email);
        localStorage.setItem(PAY_PUP_IS_ROOTUSER, isRootUser);
        localStorage.setItem(PAY_PUP_AGENCY_URL, agencyUrl);

        if (Root) {
          history(ADMIN_DASHBOARD_ROUTE);
        } else {
          history(AGENCY_DASHBOARD_ROUTE);
        }

        CustomAlertMessage(
          "You are successfully signed in!",
          "success",
          enqueueSnackbar
        );
      }
    } catch (error) {
      let { data } = error.response;

      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
      setLoading(false);
    }
  };
  //Formik
  const { handleSubmit, handleChange, values, errors, touched } = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema,
    onSubmit: (values) => saveFormValues(values),
  });
  return (
    <div className="login-form">
      <img alt="Logo" className="logo" src={logo} />
      <h4>Reset Password</h4>
      <p className="mb-4">Change Your Password</p>
      <Form form="true" onSubmit={handleSubmit}>
        <FormGroup>
          <Label for="oldPassword">Old Password</Label>
          <InputGroup>
            <Input
              type={oldPasswordShown ? "text" : "password"}
              name="oldPassword"
              id="oldPassword"
              placeholder="Enter Your Password"
              value={values.oldPassword}
              invalid={errors.oldPassword && touched.oldPassword ? true : false}
              onChange={handleChange}
            />
            <>
              <InputGroupText
                onClick={oldTogglePassword}
                style={{ cursor: "pointer" }}
              >
                {oldPasswordShown ? (
                  <img src={Iconawesomeeye} alt=""/>
                ) : (
                  <img src={Iconionicmdeyeoff} alt=""/>
                )}
              </InputGroupText>
            </>
            <FormFeedback>
              {errors.oldPassword && touched.oldPassword
                ? errors.oldPassword
                : ""}
            </FormFeedback>
          </InputGroup>
        </FormGroup>
        <FormGroup>
          <Label for="newPassword">New Password</Label>
          <InputGroup>
            <Input
              type={passwordShown ? "text" : "password"}
              name="newPassword"
              id="newPassword"
              placeholder="Enter New Password"
              value={values.newPassword}
              invalid={errors.newPassword && touched.newPassword ? true : false}
              onChange={handleChange}
            />
            <>
              <InputGroupText
                onClick={togglePassword}
                style={{ cursor: "pointer" }}
              >
                {passwordShown ? (
                  <img src={Iconawesomeeye} alt=""/>
                ) : (
                  <img src={Iconionicmdeyeoff} alt=""/>
                )}
              </InputGroupText>
            </>
            <FormFeedback>
              {errors.newPassword && touched.newPassword
                ? errors.newPassword
                : ""}
            </FormFeedback>
          </InputGroup>
        </FormGroup>
        <FormGroup>
          <Label for="confirmPassword">Confirm Password</Label>
          <InputGroup>
            <Input
              type={confirmpasswordShown ? "text" : "password"}
              name="confirmPassword"
              placeholder="Confirm Your Password"
              id="confirmPassword"
              value={values.confirmPassword}
              invalid={
                errors.confirmPassword && touched.confirmPassword ? true : false
              }
              onChange={handleChange}
            />
            <>
              <InputGroupText
                onClick={confirmTogglePassword}
                style={{ cursor: "pointer" }}
              >
                {confirmpasswordShown ? (
                  <img src={Iconawesomeeye} alt=""/>
                ) : (
                  <img src={Iconionicmdeyeoff} alt=""/>
                )}
              </InputGroupText>
            </>
            <FormFeedback>
              {errors.confirmPassword && touched.confirmPassword
                ? errors.confirmPassword
                : ""}
            </FormFeedback>
          </InputGroup>
        </FormGroup>
        {/* button */}
        <div className="top-btn">
          <Button type="submit" color="primary">
            {loading && <CustomButtonLoader loading={loading} />}
            Save Changes
          </Button>
        </div>
      </Form>
    </div>
  );
}
